// eslint-disable-next-line no-restricted-imports -- no palette slot suits the team avatar disc in both schemes
import { grey } from "@flat-ui";

/**
 * Background of the avatar that stands for a team: a white icon on a mid-grey disc.
 *
 * It is the same in both colour schemes, because no palette slot is that dark in the light scheme
 * and that light in the dark one. Delete this once flat-ui offers a team avatar colour of its own.
 */
export const TEAM_AVATAR_BACKGROUND = grey[700];